import axios from 'axios';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';
import { Endpoint, URL_PARTS } from '../base/endpoints';
import buildRequestUrl from './buildRequestUrl.util';

type Props = {
  endpoint: Endpoint;
  id: string;
  urlParams?: Record<string, string | number | boolean | string[]>;
};

const MAX_PAGES = 50; // Safety limit to prevent infinite loops

export default async function fetchAllPages({ endpoint, id, urlParams }: Props) {
  const allData: any[] = [];
  let currentPage = 1;
  let totalPages = 1;

  do {
    try {
      const { method } = URL_PARTS[endpoint];
      const paginatedUrlParams = {
        ...urlParams,
        'page[number]': currentPage,
      };
      const url = buildRequestUrl({ endpoint, id, urlParams: paginatedUrlParams });

      const response = await axios({ method, url });
      const normalizedData = normalizeJSONAPIResponse(response.data);

      allData.push(...normalizedData);

      // Update total pages from meta
      if (response.data?.meta?.['total-pages']) {
        totalPages = response.data.meta['total-pages'];
      }

      currentPage++;
    } catch (error) {
      console.error(`Error fetching page ${currentPage} for endpoint ${endpoint}:`, error);
      throw error;
    }
  } while (currentPage <= totalPages && currentPage <= MAX_PAGES);

  return allData;
}
